export const pl = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Dodaj tekst',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Dodaj do Koszyka',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Wyrównaj dno',
  ALIGN_CENTER_KEY: 'wyrównaj środek',
  ALIGN_KEY: 'wyrównać',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'wyrównaj środek',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Wyrównaj wierzchołek',
  ALL_TAB_TITLE_KEY: 'Wszystkim',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Tło',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY: 'Nie znaleziono inspiracji w tej kategorii',
  BRING_TO_FRONT_KEY: 'Przenieś na przód',
  CANCEL_TEXT_KEY: ' Anuluj ',
  CENTIMETERS_KEY: 'centymetry',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Wybierz plik',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Wyczyść wszystko',
  CLEAR_COLOR_KEY: 'Wyczyść kolor',
  CLOSE_WINDOW_KEY: 'Zamknij okno',
  CLEAR_ALL_OBJECTS: 'Wyczyść wszystkie obiekty',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Spowoduje to usunięcie wszystkich obiektów z tła.',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Kolor',
  CONTINUE_KEY: 'Kontynuuj...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Projekt',
  DELETE_KEY: 'Usuń',
  DOCUMENT_COLORS: 'Kolory dokumentu',
  DONE: 'Done!',
  DONE_KEY: 'Gotowe',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Pobierz',
  DOWNLOAD_APP_TITLE_KEY: 'Tutaj możesz pobrać aplikację:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Import z konta Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Wyszukiwanie Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Obrazy Dreamstime',
  DUPLICATE_KEY: 'Duplikuj',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Edytuj projekt',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Przepraszamy, wystąpił błąd. Spróbuj ponownie później.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Ojej, wystąpił błąd podczas otwierania pobranego pliku PDF.',
  EMAIL_KEY: 'E-mail',
  EMAIL_ADDRESS_KEY: 'Adres e-mail:',
  EMAIL_CHECKBOX_MESSAGE:
    'Wiem, że ta osoba jest świadoma, iż będzie otrzymywać e-maile od firmy HP w imieniu moim lub dostawcy tej usługi.',
  EXTRA_INFO_KEY: 'Informacje dodatkowe',
  EMAIL_NOTIFICATION:
    'Wiadomość e-mail zostanie wkrótce wysłana. Poczekaj 15 minut na przetwarzanie.',
  EMAIL_DIALOG_MESSAGE:
    'Wpisz adres e-mail osoby, której chcesz udostępnić projekt.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Istniejący folder',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Przed przejściem do kasy sprawdź wszystkie wybrane elementy',
  FINAL_CHECK_TITLE_KEY: 'Ostateczny sprawdzian',
  FINISH_KEY: 'Zakończ',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Przerzuć',
  FOR_KEY: 'dla',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Słowa kluczowe:',
  FOLDER_NAME: 'Nazwa folderu',
  FOLDER_NAME_KEY: 'Nazwa folderu:',
  FOLDER_ALREADY_EXIST_KEY: 'Ta nazwa folderu już istnieje',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Grupuj wszystko',
  GROUP_SCALE: 'Skala grupy',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Nazwij swój projekt',
  HEIGHT_KEY: 'Wysokość',
  HELP_KEY: 'Pomoc',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'OBRAZY',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Importowanie',
  INCHES_COLUMN_HEADER_KEY: 'Cale',
  INCHES_KEY: ' cali',
  INCHES_UNIT_STRING_KEY: 'cal',
  INVALID_EMAIL_ADDRESS_KEY: 'Nieprawidłowy adres e-mail',
  INVALID_INFO_KEY: 'Wprowadź szczegóły.',
  INVALID_NAME_KEY: 'Nieprawidłowa nazwa',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Przepraszamy, ale wybrany plik jest za duży. Maksymalny rozmiar pliku to 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Ojej, to nie jest prawidłowy format pliku. Obsługiwane są tylko pliki pdf, jpg, png, svg oraz tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Język',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Dowiedz się więcej',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Korzystając z tej strony, użytkownik wyraża zgodę na',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Ta strona spełnia warunki',
  LEGAL_FOOTER_MESSAGE3_KEY: 'oraz',
  LENGTH_STRING_IN_INCHES_KEY: 'cal',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Aby zwizualizować dodawaną zawartość, pobierz aplikację LinkReader.',
  LOADING_KEY: 'Ładowanie',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Zablokuj',
  LOGIN_KEY: 'Zaloguj',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Zaloguj się do Dreamstime ',
  LOGOUT_KEY: 'Wyloguj',
  MATERIAL_TITLE_KEY: 'MATERIAŁ',
  MATERIAL_STRING_KEY: 'Materiał',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Nie można dalej skalować tego tła w dół, ponieważ osiągnięto minimalną wysokość lub szerokość wymaganą do pokrycia ściany.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'Więcej informacji',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Nazwa:',
  NEXT_BUTTON_TITLE_KEY: 'DALEJ',
  NEW_FOLDER_KEY: 'Nowy folder',
  NO_SHADOW_KEY: 'Bez cienia',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Zamów próbkę',
  ORDER_SAMPLE: 'Zamów próbkę',
  ORDER_SAMPLE_INFOLABEL_1:
    'Wybierz fragment obrazu, który chcesz zamówić jako próbkę',
  ORDER_SAMPLE_INFOLABEL_2:
    'Otrzymasz wiadomość e-mail z dokładnym podglądem projektu w jego rzeczywistym rozmiarze',
  ORDER_SAMPLE_INFOLABEL_3: 'Pozwoli to ocenić jego jakość i rozdzielczość',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Zamów próbkę teraz',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Otrzymasz wiadomość e-mail zawierającą przybliżony widok projektu w rzeczywistym rozmiarze w celu oceny jego jakości/rozdzielczości.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Hasło',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Posiadam prawa do tego obrazu i zgadzam się z',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Piksel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'Np. pewne ważne informacje, które chcesz przekazać do drukarni',
  PLACEHOLDER_INCHES_STRING_KEY: 'cal',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Pozycja',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Zapisz projekt',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'W projekcie są zmiany, które muszą zostać zapisane przed kontynuowaniem.',
  PRICE_COLUMN_HEADER_KEY: 'Cena',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Przetwarzanie...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Podgląd',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Nazwa projektu',
  PROJECT_NAME: 'Nazwa projektu:',
  PROJECT_ALREADY_EXIST_KEY: 'Ta nazwa projektu już istnieje',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Ta nazwa projektu już istnieje',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Ta nazwa folderu już istnieje',
  PIXELATION_WARNING_KEY: 'Ostrzeżenie o pikselach',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Ze względu na rozdzielczość przesłanego zdjęcia Twoja skóra może być zniekształcona lub zniekształcona. Aby upewnić się, że nie ma rozmycia, prześlij obraz dobrej jakości i unikaj rozciągania obrazu. Jeśli podgląd jest zadowalający i chcesz kontynuować, kontynuuj przesyłanie.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: '*Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'WYMAGANE',
  RECOLOR_KEY: 'Zmień kolor',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Zmień kolor',
  REQUEST_SAMPLE_KEY: 'Poproś o próbkę',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Zapytanie ofertowe',
  RIGHT_LOGO_TEXT_KEY: 'przez',
  ROTATE_KEY: 'Obróć',
  ROTATE_LEFT_KEY: 'Obróć o 90° w lewo',
  ROTATE_RIGHT_KEY: 'Obróć o 90° w prawo',
  ROTATION_KEY: 'Obrót',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Wiersze i kolumny',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Zapisz',
  SAVING_KEY: 'Zapisywanie...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Zapisz projekt',
  SAVE_PROJECT_NAME_KEY: 'Najpierw zapisz projekt',
  SAVEDIALOG_MESSAGE:
    'Zaloguj się, aby zapisać projekt. Jeśli nie masz konta, pomożemy je założyć. Twoja praca nie zostanie utracona.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Skaluj',
  SCALE_ALL_KEY: 'Skaluj wszystko',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Wyszukaj',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Wyszukaj',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Wyślij instrukcje instalacji',
  SEND_TO_BACK_KEY: 'Wyślij na tył',
  SEND_KEY: 'Wyślij',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Ustaw rozmiar',
  SETTINGS_KEY: 'Ustawienia',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Udostępnij',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'st. kw.',
  SQM_UNIT_STRING_KEY: 'm kw.',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'Zatwierdź',
  SHARE_LINK_LABEL: 'Wybierz typ łącza, które chcesz udostępnić',
  SHARE_EDIT_LINK: 'Edytuj łącze',
  SHARE_VIEW_LINK: 'Wyświetl łącze',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Docelową odległość oglądania można zmienić w ustawieniach.',
  TERMS1_KEY: 'warunki',
  TERMS2_KEY: 'Oświadczenie o ochronie prywatności HP',
  TERMS3_KEY: 'Informacje dotyczące ochrony danych osobowych HP',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Warunki użytkowania',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Podziel na części',
  TOTAL_KEY: 'SUMA',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'TEMPLATES',
  TEMPLATES_UPPER_CASE_KEY: 'Szablony',
  THANK_YOU_KEY: 'Dziękuję',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Odblokuj',
  UNGROUP_KEY: 'Usuń z grupy',
  UPDATE_TEXT_KEY: 'Uaktualnij',
  UPLOAD_KEY: 'Przesyłanie obrazu',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Nazwa użytkownika',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Połącz w całość',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Ważność',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'Podatek VAT',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Wyświetl w serwisie Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Wyświetl szczegóły projektu',
  VIEW_DESIGNER_PROFILE_KEY: 'Wyświetl profil trybu projektanta',
  VIEW_PRICE_KEY: 'Wyświetl cenę',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Plakat',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Ostrzeżenie',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Szerokość',

  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Nazwa',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Twój projekt:',
  PROJECT_NAME_ERROR_TEXT: 'Wprowadź nazwę projektu.',
  PROJECT_FOLDER_ERROR_TEXT: 'Wprowadź nazwę folderu projektu.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimalna odległość oglądania',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Nie znaleziono zawartości Dreamstime',
  NO_ELEMENT_ERROR_MESSAGE: 'Nie znaleziono elementu.',
  NO_MORE_IMAGES_FOUND_KEY: 'Nie znaleziono więcej zdjęć',
  NO_PATTERN_ERROR_MESSAGE: 'Nie znaleziono wzorów.',
  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Wiadomość:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Przeskalowano do rozmiaru, przy którym wydrukowany oraz może być niewyraźny podczas wyświetlania w rozdzielczości {0} {1} * (aktualna rozdzielczość drukowanego obrazu to {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Zalecana odległość oglądania będzie wynosić {0} {1}. Jeśli nie jest ona odpowiednia, zmniejsz skalę tego obrazu lub rozmiar dekoracji ściany.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Zalecany minimalny rozmiar obrazu to {0} x {1} pikseli.',
  UPLOAD_STATUS: '{0}% z {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Minimalne wymiary to {0} (sz) na {1} (w).',
  MINIMUM_HEIGHT_KEY: 'Minimalna wysokość to {0}.',
  MINIMUM_WIDTH_KEY: 'Minimalna szerokość to {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Maksymalna szerokość to {0}',
  MAXIMUM_HEIGHT_KEY: 'Maksymalna wysokość to {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Podaj wymiary w liczbach większych od zera.',
  PROCESSING_FAILED: 'Błąd przetwarzania, spróbuj za jakiś czas',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Przepraszamy, wielostronicowe pliki PDF nie są obsługiwane.',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Niestety, szyfrowane pliki PDF nie są obsługiwane.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importowanie pliku {0} z {1}',
  RECOLORING_KEY: 'Zmiana koloru...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE: 'To źródło jest chronione hasłem',
  AUTHENTICATE_FAILED_MESSAGE: 'Błąd uwierzytelniania!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Wystąpił problem podczas importowania niektórych plików',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Ten szablon inspiracji ma domyślny rozmiar {0} X {1} {2}. Rozmiar strony zostanie automatycznie zmieniony, aby pasował do tego szablonu.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Wybierz swój laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Imię',
  LAST_NAME_KEY: 'Nazwisko',
  PHONE_NUMBER_KEY: 'Nr telefonu',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Nieprawidłowy numer telefonu',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'Akceptuję regulamin',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Zgadzam się na udostępnienie moich danych osobowych firmie HP na potrzeby kontaktu w sprawie przyszłych kampanii HP*.',
  SERVICE_PROVIDER_CONDITION:
    'Zgadzam się na udostępnienie podanych przez mnie danych usługodawcom na potrzeby wydrukowania i dostarczenia produktu*.',
  ORDER_DESIGN: 'Zamów projekt',
  SUBMIT_YOUR_DESIGN: 'Prześlij projekt graficzny',
  SUBMISSION_DESIGN_ORDER: 'Złożenie zamówienia na projekt',
  ENTER_REQUIRED_FIELDS_KEY: 'Wypełnij pola wymagane',
  ADDRESS_KEY: 'Nr domu/lokalu',
  INVALID_ADDRESS_KEY: 'Nieprawidłowy adres',
  CITY_KEY: 'Miejscowość',
  INVALID_CITY_KEY: 'Nieprawidłowa miejscowość',
  COUNTRY_KEY: 'Kraj',
  STATE_KEY: 'Województwo',
  ZIP_KEY: 'Kod pocztowy',
  INVALID_ZIP_KEY: 'Nieprawidłowy kod pocztowy',
  ORDER_NUMBER: 'Numer zamówienia',
  YOUR_DETAILS_KEY: 'Twoje szczegóły',
  APPLY_DESIGN_COMPETITION: 'Zgłoś do konkursu na projekt graficzny',
  NOTICE_KEY: 'Ogłoszenie:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Aby mieć idealnie dopasowaną skórkę do komputera, musisz wybrać dokładny model odpowiadający zakupowi, jak widać na fakturze.',
  RESTART_PROJECT_ALERT_TITLE: 'Uruchomić ponownie projekt?',
  DISCARD_ALERT_MESSAGE: 'Aktualny projekt zostanie odrzucony',
  RESTART: 'Uruchom ponownie',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Ostrzeżenie o rozmiarze strony!',
  MODIFY_SIZE_WARNING:
    'Jeśli chcesz zmienić rozmiar tego projektu, możesz to zrobić na karcie „Ustawienia”. Elementy projektu mogą wymagać edycji w celu dostosowania do żądanych wymiarów.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Zastosowano wybór materiału.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Łańcuch bloków',
  CERTIFICATE_STRING: 'certyfikat',
  AUTHENTICITY_STRING: 'autentyczności',
  PLEASE_WAIT: 'Czekaj',
  PROTECTING_YOUR_DATA: 'trwa zabezpieczanie danych...',
  SEARCH_YOUR_LAPTOP_KEY: 'Wyszukaj swojego laptopa', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Ups! Nie znaleźliśmy żadnych laptopów do wyszukiwania.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Numer seryjny',
  LOCKED_PROJECT: 'Projekt zablokowany',
  LOCKED_MESSAGE:
    'Ten projekt został zamówiony i nie można go zmienić. Możesz tylko wyświetlić projekt. ',
  EXPIRED_PROJECT: 'Projekt wygasł',
  EXPIRED_MESSAGE: 'Ten projekt wygasł.',
  DELETED_PROJECT: 'Projekt usunięty',
  DELETED_MESSAGE: 'Ten projekt został usunięty.',
  CHOOSE_GROUP_TYPE: 'Wybierz rodzaj {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Wprowadź liczby większe od zera.',
  SIZE_KEY: 'Rozmiar',
  DISTANCE_FROM_KEY: 'Odległość od',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Lewy',
  RIGHT_KEY: 'Prawy',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Maksymalny rozmiar ściany to {0} kw.{1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Wysokość płótna przekracza wysokość ściany.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Szerokość płótna przekracza szerokość ściany.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Maksymalna liczba kolumn dla bieżącej szerokości: {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Maksymalna liczba wierszy dla bieżącej wysokości: {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Szerokość ściany jest mniejsza od szerokości płótna.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY: 'Minimalna szerokość ściany to {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY: 'Minimalna wysokość ściany to {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Wysokość ściany jest mniejsza od wysokości płótna.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Maksymalna wysokość ściany to {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Wiersze',
  COLUMNS_KEY: 'Kolumny',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Edytuj',
  TOP_KEY: 'Góra',
  BOTTOM_KEY: 'Dół'
};
